import { Box, styled, Typography } from "@mui/material";
import { rem } from "polished";
import React from "react";

import { MetaTags } from "src/components";

type Props = {
  children: React.ReactNode;
  title: string;
};

const StyledPageTitle = styled(Typography)`
  color: ${(props) => props.theme.palette.primary.main};
  font-weight: 800;
  font-size: clamp(2rem, 5vw, 2.5rem);
  margin-bottom: ${(props) => props.theme.spacing(10)};
  ${(props) => props.theme.breakpoints.up("sm")} {
    margin-bottom: ${(props) => props.theme.spacing(2)};
  }
`;

const StyledPageContainer = styled(Box)`
  margin: auto;
  padding: ${(props) => props.theme.spacing(2)};
  max-width: 100vw;
  word-wrap: break-word;
  overflow-wrap: break-word;

  ${(props) => props.theme.breakpoints.up("sm")} {
    padding: ${(props) => props.theme.spacing(6)};
  }
  ${(props) => props.theme.breakpoints.up("lg")} {
    padding: unset;
    max-width: ${rem(1014)};
  }
  ${(props) => props.theme.breakpoints.up("xl")} {
    max-width: ${rem(1200)};
  }
`;

const ContentPageWrapper = ({ children, title }: Props) => {
  return (
    <StyledPageContainer>
      <MetaTags title={title} />
      <StyledPageTitle variant="h3">{title}</StyledPageTitle>
      {children}
    </StyledPageContainer>
  );
};

export default ContentPageWrapper;
